export const COMPANY_STATUS_ACTIVE = 1;
export const COMPANY_STATUS_DISABLED = 2;

export const list_of_company_types: {code: 1|2; name: string}[] = [
    {code: 1, name: "Cert-Trace"},
    {code: 2, name: "GuarDoc"},
]